export enum MaintenanceWebshopModeType {
  None,
  Website,
  VU,
  All,
}
